import { useSelector } from 'react-redux';
import {
  ThemeProvider as MuiThemeProvider,
  StyledEngineProvider,
} from '@mui/material';

import { darkTheme, lightTheme } from '../components/lib/themes';

import type { RootStore } from '../types';
import type { WithChildrenProps } from '../types/components/common';

const themes = {
  dark: darkTheme,
  light: lightTheme,
};

export const NewThemeProvider = ({ children }: WithChildrenProps) => {
  const reduxThemeMode = useSelector(
    (state: RootStore) => state.uiSettings.theme
  );

  const resolvedTheme = themes[reduxThemeMode];

  return (
    <StyledEngineProvider injectFirst>
      <MuiThemeProvider theme={() => resolvedTheme}>
        {children}
      </MuiThemeProvider>
    </StyledEngineProvider>
  );
};

export default NewThemeProvider;
